import { useState, useRef, useEffect, useCallback } from "react";
import CRMButton from "./CRMButton";
import { FontIcon, TextField, TooltipHost } from "@fluentui/react";
import { useWindowDimensions, ssToast } from "ss-lib";
import { updateCRMStatus } from "../../../actions/CRM";
import useUser from "../../../hooks/useUser";
import { Toast, useToastController } from "@fluentui/react-components";

const CRMStatusCard = ({ j, stage, status }) => {
  const { user } = useUser();
  const [formData, setFormData] = useState({
    contact: false,
    owner: "",
    notes: "",
  });
  const { contact, owner, notes } = formData;
  const { width } = useWindowDimensions();
  const [openOwnerInput, setOpenOwnerInput] = useState(false);
  const [openNotesInput, setOpenNotesInput] = useState(false);
  const { dispatchToast } = useToastController(ssToast);
  const inputRef = useRef(null);

  const finishSubmit = useCallback((msg, type) => {
    setOpenOwnerInput(false);
    setOpenNotesInput(false);
    dispatchToast(
      <Toast>
        {msg}
      </Toast>
      , {type}
    )
  }, []);

  useEffect(() => {
    if (status[stage] !== {}) setFormData({ ...formData, ...status[stage] });
    //updateCRMStatus(user, j, formData, stage, finishSubmit, setFormData);
  }, []);

  const handleChange = (e) => {
    e.preventDefault();

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    console.log(formData);

    if (e.key === "Enter") {
      updateCRMStatus(user, j, formData, stage, finishSubmit, setFormData);
    }
  };

  const toggleContact = async (e) => {
    e.preventDefault();

    setFormData({ ...formData, contact: !contact });
    return updateCRMStatus(
      user,
      j,
      { ...formData, contact: !contact },
      stage,
      finishSubmit,
      setFormData
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    updateCRMStatus(user, j, formData, stage, finishSubmit, setFormData);
  };

  const getInitials = (name) => {
    const getFirst = name
      .replace(/[()of]/g, "")
      .toUpperCase()
      .split(" ")
      .map((i) => i[0])
      .join("");

    return getFirst;
  };

  return (
    <div style={{ flexDirection: "column" }}>
      <div className="basic-card crm-content-detail">
        <div className="crm-inner-title">
          {width < 1200 ? (
            <TooltipHost content={j.journal}>
              {getInitials(j.journal)}
            </TooltipHost>
          ) : (
            j.journal.replace(/University/g, "U.")
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            paddingRight: 30,
          }}
        >
          <CRMButton
            key={`${j.journal}-contact`}
            ids={["crm-sent", "crm-send"]}
            content={[
              <>
                <FontIcon iconName="InboxCheck" ariaLabel="Sent" />
              </>,
              <FontIcon iconName="MailUndelivered" ariaLabel="Send" />,
            ]}
            tooltipProps={["Contacted", "Not Contacted"]}
            name="contact"
            value={contact}
            isValid={contact}
            onClick={toggleContact}
          />
          <TooltipHost
            content={
              owner !== "" && owner !== undefined ? "Assigned" : "Unassigned"
            }
          >
            <div
              id={
                owner !== "" && owner !== undefined ? "crm-owner" : "crm-assign"
              }
              className="crm-btn"
              ref={inputRef}
              onClick={(e) => {
                e.preventDefault();
                setOpenOwnerInput(true);
              }}
            >
              {owner !== "" && owner !== undefined ? (
                <FontIcon iconName="UserFollowed" />
              ) : (
                <FontIcon iconName="AddFriend" />
              )}
            </div>
          </TooltipHost>

          <TooltipHost content={notes !== "" ? "Notes" : "Add Notes"}>
            <div
              id={notes !== "" ? "crm-notes" : "crm-empty"}
              className="crm-btn"
              onClick={(e) => {
                e.preventDefault();
                setOpenNotesInput(true);
              }}
            >
              {notes !== "" ? (
                <FontIcon iconName="EditNote" ariaLabel="Edit Notes" />
              ) : (
                <FontIcon iconName="AddNotes" ariaLabel="Add Notes" />
              )}
            </div>
          </TooltipHost>
        </div>
      </div>
      {openOwnerInput && (
        <div style={{ justifyContent: "center" }}>
          <form
            className="crm-alert modal-light"
            style={{ margin: "20px auto 20px auto" }}
          >
            <div className="crm-journal-header" id="modal-header">
              Update owner
            </div>
            <TextField
              type="text"
              onChange={handleChange}
              onKeyDown={(e) => {
                e.key === "Enter" && handleSubmit(e);
              }}
              placeholder="Add or update owner"
              name="owner"
              value={owner}
              style={{
                width: "100%",
                border: "none",
                background: "inherit",
              }}
            />
            <div className="alert-footer" ref={inputRef}>
              <div
                className="alert-button"
                id="dismiss-alert"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenOwnerInput(false);
                }}
              >
                Cancel
              </div>
              <div className="alert-button" onClick={handleSubmit}>
                Ok
              </div>
            </div>
          </form>{" "}
        </div>
      )}
      {openNotesInput && (
        <div style={{ justifyContent: "center" }}>
          <form
            className="crm-alert modal-light"
            style={{ margin: "20px auto 20px auto" }}
          >
            <div className="crm-journal-header" id="modal-header">
              Update notes
            </div>
            <TextField
              multiline
              type="text"
              rows="7"
              onChange={handleChange}
              onKeyDown={(e) => {
                e.key === "Enter" && handleSubmit(e);
              }}
              placeholder="Add notes"
              name="notes"
              value={notes}
              style={{ width: "100%", border: "none", background: "inherit" }}
            />
            <div className="alert-footer" ref={inputRef}>
              <div
                className="alert-button"
                id="dismiss-alert"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenNotesInput(false);
                }}
              >
                Cancel
              </div>
              <div className="alert-button" onClick={handleSubmit}>
                Ok
              </div>
            </div>
          </form>{" "}
        </div>
      )}
    </div>
  );
};

export default CRMStatusCard;
